import React from 'react';
import ShiftForm from './ShiftForm.tsx';
import ShiftsCard from './ShiftsCard.tsx';
import ManpowerCoverageCard from './ManpowerCoverageCard.tsx';
import { useWorkingDate } from '../contexts/WorkingDateContext.tsx';

/**
 * Shifts: planning the roster. Create shifts, read the day's coverage (need vs. have), and edit
 * individual shifts in the Day / Week / Month roster grid. (Who is where on the day is the Manpower tab.)
 *
 * The date is the shared working date, so arriving here from the Board or Manpower stays on the same day.
 */
const ShiftsPage: React.FC = () => {
  const [searchDate, setSearchDate] = useWorkingDate();
  return (
    <div className="card">
      <h1>Shifts</h1>

      <div className="card" style={{ marginBottom: '16px' }}>
        <h3 style={{ marginTop: 0 }}>Create Shifts</h3>
        <ShiftForm />
      </div>

      {/* Demand vs supply for the selected day: pick each site's staffing model, then read the total
          needed against who is actually on shift. The question a scheduling-only product cannot answer. */}
      <ManpowerCoverageCard selectedDate={searchDate} />

      <div className="card">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px', flexWrap: 'wrap' }}>
          <h3 style={{ margin: 0 }}>Roster</h3>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <label htmlFor="shiftsDate" style={{ whiteSpace: 'nowrap' }}>Date:</label>
            <input
              id="shiftsDate"
              type="date"
              className="form-control"
              value={searchDate}
              onChange={(e) => setSearchDate(e.target.value)}
            />
          </div>
        </div>
        <div style={{ marginTop: '10px' }}>
          <ShiftsCard selectedDate={searchDate} hasPersistedAllocations={false} showDeleteAll={true} gridView={true} />
        </div>
      </div>
    </div>
  );
};

export default ShiftsPage;
